<template>
  <AppModal
    :open="store.prefsModalOpen"
    :title="t('public.cookieConsent.modalTitle')"
    bottom-sheet
    stack-on-top
    test-id="cookie-prefs-modal"
    @close="onClose"
  >
    <div class="space-y-5 text-sm text-charcoal dark:text-slate-200">
      <div class="rounded-xl border border-slate-200 dark:border-zinc-700 p-3 bg-slate-50/80 dark:bg-zinc-800/50">
        <p class="font-semibold">{{ t('public.cookieConsent.necessaryTitle') }}</p>
        <p class="text-slate-600 dark:text-slate-400 mt-1 text-xs sm:text-sm">
          {{ t('public.cookieConsent.necessaryDesc') }}
        </p>
      </div>

      <label class="flex gap-3 items-start cursor-pointer min-h-[44px]">
        <input
          v-model="localAnalytics"
          type="checkbox"
          class="mt-1 h-5 w-5 rounded border-slate-300 text-primary focus:ring-primary"
        />
        <span>
          <span class="font-semibold block">{{ t('public.cookieConsent.analyticsTitle') }}</span>
          <span class="text-slate-600 dark:text-slate-400 text-xs sm:text-sm">{{ t('public.cookieConsent.analyticsDesc') }}</span>
        </span>
      </label>

      <label class="flex gap-3 items-start cursor-pointer min-h-[44px]">
        <input
          v-model="localThirdParty"
          type="checkbox"
          class="mt-1 h-5 w-5 rounded border-slate-300 text-primary focus:ring-primary"
        />
        <span>
          <span class="font-semibold block">{{ t('public.cookieConsent.thirdPartyTitle') }}</span>
          <span class="text-slate-600 dark:text-slate-400 text-xs sm:text-sm">{{ t('public.cookieConsent.thirdPartyDesc') }}</span>
        </span>
      </label>
    </div>
    <template #footer>
      <button
        type="button"
        class="min-h-[44px] px-4 rounded-xl border border-slate-300 dark:border-zinc-600 font-semibold text-sm"
        @click="onClose"
      >
        {{ t('app.cancel') }}
      </button>
      <button
        type="button"
        class="min-h-[44px] px-4 rounded-xl bg-primary text-white font-semibold text-sm"
        @click="onSave"
      >
        {{ t('public.cookieConsent.save') }}
      </button>
    </template>
  </AppModal>
</template>

<script setup>
import { ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import AppModal from '@/components/ui/AppModal.vue'
import { useCookieConsentStore } from '@/stores/sitePrefs'

const { t } = useI18n()
const store = useCookieConsentStore()
const localAnalytics = ref(false)
const localThirdParty = ref(false)

watch(
  () => store.prefsModalOpen,
  (open) => {
    if (open) {
      localAnalytics.value = store.analytics
      localThirdParty.value = store.thirdParty
    }
  }
)

function onClose() {
  store.closePrefs()
}

function onSave() {
  store.saveCustom(localAnalytics.value, localThirdParty.value)
}
</script>
